import { DataSource } from '@/datasources/consulte-grid';
import { FiltroEstudanteModel } from '@/models/filtros/filtro-estudante.model';
import FiltroEstudanteService, {
  FiltroEstudantePesquisa,
} from '@/services/filtros/filtroestudante.service';

export default class FiltroEstudanteDataSource extends DataSource<FiltroEstudanteModel> {
  private escolaId?: number | null;
  private pesquisa?: FiltroEstudantePesquisa;
  constructor(
    pageNumber: number,
    rowsPerPage: number,
    rowsPageCount: number,
    totalRowCount: number,
    rows: FiltroEstudanteModel[],
    onLoad?: (rows: any) => void,
    escolaId?: number | null,
    pesquisa?: FiltroEstudantePesquisa,
    private onErro?: (erro: unknown) => void,
  ) {
    super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<FiltroEstudanteModel>());
    if (onLoad) this.setOnLoad(onLoad);
    this.escolaId = escolaId;
    this.pesquisa = pesquisa;
  }

  async load(): Promise<any> {
    try {
    const result = (
      await FiltroEstudanteService.dadosIndexPaginado(
        this.pageNumber,
        this.rowsPerPage,
        this.filters,
        this.escolaId,
        null,
        this.pesquisa,
      )
    ).data as DataSource<FiltroEstudanteModel>;

    this.pageNumber = result.pageNumber;
    this.rowsPageCount = result.rowsPageCount;
    this.rowsPerPage = result.rowsPerPage;
    this.rows = result.rows;
    this.sortDataField = result.sortDataField;
    this.sortOrder = result.sortOrder;
    this.totalRowCount = result.totalRowCount;
    this.filters = result.filters;

    return super.load();
    } catch (erro) {
      if (!this.onErro) throw erro;
      this.rows = [];
      this.totalRowCount = 0;
      this.rowsPageCount = 0;
      this.calculateNumberOfPages();
      this.onErro(erro);
      return super.load();
    }
  }
}
